import React, { useEffect, useRef } from 'react';
export function MatrixCanvas() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    let width = window.innerWidth;
    let height = window.innerHeight;
    let animationFrameId: number;
    const resize = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    };
    window.addEventListener('resize', resize);
    resize();
    const cols = Math.floor(width / 18);
    const drops = Array(cols).fill(0).map(() => Math.random() * -100);
    const chars = '01アイウエオカキクケコサシスセソタチツテトナニヌネノ';
    const draw = () => {
      ctx.fillStyle = 'rgba(2, 5, 16, 0.06)';
      ctx.fillRect(0, 0, width, height);
      ctx.fillStyle = '#00ff9f';
      ctx.font = '14px monospace';
      drops.forEach((y, i) => {
        const text = chars[Math.floor(Math.random() * chars.length)];
        const x = i * 18;
        ctx.fillText(text, x, y * 18);
        if (y * 18 > height && Math.random() > 0.975) {
          drops[i] = 0;
        }
        drops[i] += 0.2;
      });
      animationFrameId = requestAnimationFrame(draw);
    };
    draw();
    return () => {
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  return <canvas ref={canvasRef} className="fixed top-0 left-0 w-full h-full z-0 opacity-[0.13] pointer-events-none" data-id="element-22" />;
}